export const colors = [
    {
        id:"pinky"
    },
    {
        id:"orange"
    },
    {
        id:"yellow"
    },
    {
        id:"green"
    },
    {
        id:"cyan"
    },
    {
        id:"purple"
    }
];

export const options = {
    month: "short",
    day: "numeric"
  };